import React, { useState, useEffect, useRef} from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from 'server/serverController2';
import { compressImage, removeItem, insertItem } from 'utils/utils';

import CommunityFilter from 'components/presenters/community/CommunityFilter';
import CommunityWriteForm from 'components/presenters/community/CommunityWriteForm';
import CommunityList from 'components/presenters/community/CommunityList';
import CenterModal from 'components/presenters/modal/CenterModal';
import BottomModal from 'components/presenters/modal/BottomModal';
import likeAnimation from 'images/lottiefile/like_animation_red.json' 

const Community = ({no, isOwner, type}) => {
    const userInfo = useSelector((state) => {
        return state['userInfo'];
    })
    
    const history = useHistory();

    const [postList, setPostList] = useState([]);
    const [lastposNo, setLastPosNo] = useState(null);
    const [writeType, setWriteType] = useState(null);
    const [writeValue, setWriteValue] = useState(null);
    const [imageList, setImageList] = useState([]);
    const [currImgCapacity, setCurrImgCapacity] = useState(0);
    const [currPostNo, setCurrPostNo] = useState(null)
    const [currFilterNo, setCurrFilterNo] = useState(null);
    const [writeVisible, setWriteVisible] = useState(false);
    const [initWriteFormState, setInitWriteFormState] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    //Animation
    const [isLikeAnimation, setIsLikeAnimation] = useState(false);
    //CenterModal
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState(null);
    const [onCenterModalComplete, setOnCenterModalComplete] = useState(null);
    const [onCenterModalCancel, setOnCenterModalCancel] = useState(null);
    const [initCenterModalState, setInitCenterModalState] = useState(false);
    //BottomModal
    const [bottomModalVisible, setBottomModalVisible] = useState(false);
    const [bottomModalDataList, setBottomModalDataList] = useState([]);
    const [initBottomModalState, setInitBottomModalState] = useState(false);
 
    const fileInputRef = useRef(null);
    //PostForm
    const handleChangeWriteType = (e) => {
        const type = e.currentTarget.getAttribute('data-type');
        setWriteType(type);
    }

    const handleChangeWriteValue = (e) => {
        const value = e.target.value;
        setWriteValue(value);
    }

    const handleChangeImageList = async (e) => {
        const imgMaxCapacity = 10;
        let imgCapacity = currImgCapacity;
        if((currImgCapacity+(e?.target?.files?.length)) > imgMaxCapacity)
        {
            setCenterModalVisible(true);
            setCenterModalDataList({type: 'callback', description: '이미지는 10개까지 가능해요'})
            setOnCenterModalComplete(() => () => setCenterModalVisible(false));
            return;
        }

        const copyImageList = [];
        const value = e.target.files;
        for(let key of Object.keys(value))
        {
            const compressedImg = await compressImage(value[key]);
            copyImageList.push({type: 'newImage', data:compressedImg});
            ++imgCapacity;
        }
        fileInputRef.current.value = null;
        setCurrImgCapacity(imgCapacity);
        setImageList([...imageList, ...copyImageList]);
    }

    const handleClickDeleteImage = (index) => {
        const copyImageList = Object.assign(imageList);
        const reloadImageList = removeItem(copyImageList, index);
        setCurrImgCapacity(parseInt(reloadImageList.length));
        setImageList(reloadImageList);
    }

    const handleInsertPostCallback = (res) => {
        try
        {
            if(res['success'] !== 1)
            {
                return;
            }
            const insertedItem = res['data']['inserted_item'];
            insertedItem['nickname'] = userInfo['name'];
            insertedItem['profile_img'] = userInfo['profile_img'];
            insertedItem['role'] = userInfo['role'];
            insertedItem['total_comment'] = 0;
            insertedItem['total_like'] = 0;
            insertedItem['liked_post'] = false;

            let index  = 0;
            for(let i = 0; i < postList.length; ++i)
            {
                if(postList[i]['pin'] === false)
                {
                    index = i;
                    break;
                }
            }

            const reloadPostList = insertItem(postList, index, insertedItem);
            setPostList(reloadPostList);
            setInitWriteFormState(true);
            setIsSubmitting(false);
        }
        catch(error)
        {
            console.log(error);
        }
    }

    const handleFileUploadCallback = async (res) => {
        try 
        {
            if(res['success'] !== 1)
            {
                return;
            }
            const imgPathList = [];
            const uploadItem = res['data']['upload_results'];
            uploadItem.map((item) => {
                imgPathList.push(item['file_name']);
            })

            const body = {
                category_no: writeType,
                content: writeValue,
                img_attachment: imgPathList
            }
            if(type === 'campaign')
            {
                await server.postRequestData(`campaigns/${no}/posts`, JSON.stringify(body), handleInsertPostCallback);
            }
            else if(type === 'group')
            {
                await server.postRequestData(`groups/${no}/posts`, JSON.stringify(body), handleInsertPostCallback)
            }
        }
        catch(error)
        {
            console.log(error)
        }
    }

    const onSubmitFormData = async () => {
        const formData = new FormData();

        if(type === 'campaign')
        {
            formData.append('path', 'campaign_post_img/')
        }
        else if(type === 'group') 
        {
            formData.append('path', 'group_post_img/')
        }

        for(let i = 0; i < imageList.length; ++i)
        {
            if(imageList[i]['type'] === 'newImage')
            {
                formData.append('file', imageList[i]['data']);
            }
        }
        
        await server.postRequestFormData(`file`, formData, handleFileUploadCallback)
    } 

    const handleCancelWrite = () => {
        setInitWriteFormState(true);
    }

    const handleSubmit = async () => {
        if([null, undefined].includes(writeType))
        {
            setCenterModalVisible(true);
            setCenterModalDataList({type: 'callback', description: '카테고리를 선택해주세요'});
            setOnCenterModalComplete(() => () => setInitCenterModalState(true));
            return;
        }
        else if(writeValue === null && imageList.length === 0)
        {
            setCenterModalVisible(true);
            setCenterModalDataList({type: 'callback', description: '게시글을 입력해주세요'});
            setOnCenterModalComplete(() => () => setInitCenterModalState(true));
            return;
        }

        if(isSubmitting === false)
        {
            setIsSubmitting(true);
            if(imageList.length !== 0)
            {
                onSubmitFormData();
            }
            else
            {
                const body = {
                    category_no: writeType,
                    content: writeValue
                }

                if(type === 'campaign')
                {
                    await server.postRequestData(`campaigns/${no}/posts`, JSON.stringify(body), handleInsertPostCallback)
                }
                else if(type === 'group')
                {
                    await server.postRequestData(`groups/${no}/posts`, JSON.stringify(body), handleInsertPostCallback);
                }
            }
        }
    }
    //EndPostForm
    //PostList
    const handleAddLike = async (params) => {
        const endPoint = type === 'campaign' ? `campaigns/posts/${params['no']}/like` : `groups/posts/${params['no']}/like`;
        setCurrPostNo(params['no']);
        server.postRequestData(endPoint, {}, (res) => {
            try
            {
                if(res['success'] !== 1)
                {
                    return;
                }
                setIsLikeAnimation(true);
                const insertedItem = res['data']['inserted_item'];
                const posts = [...postList];
                posts.map((post) => {
                    if(post['no'] === insertedItem['post_no'])
                    {
                        post['total_like'] = parseInt(post['total_like']) + 1;
                        post['liked_post'] = true;
                    }
                });
                setPostList(posts);
                setTimeout(() => {
                    setIsLikeAnimation(false);
                }, 1500);
            }
            catch(error)
            {
                console.log(error);
            }
        })
    }

    const handleDeleteLike = (params) => {
        const endPoint = type === 'campaign' ? `campaigns/posts/${params['no']}/like` : `groups/posts/${params['no']}/like`;
        server.deleteRequestData(endPoint, {}, (res) => {
            try
            {
                if(res['success'] !== 1)
                {
                    return;
                }
                const deletedItem = res['data']['deleted_item'][0];
                const posts = [...postList];
                posts.map((post) => {
                    if(post['no'] === deletedItem['post_no'])
                    {
                        post['total_like'] = parseInt(post['total_like']) - 1;
                        post['liked_post'] = false;
                    }
                });
                setPostList(posts);
            }
            catch(error)
            {
                console.log(error);
            }
        })
    }

    const deletePost = async (post) => {
        try
        {
            const endPoint = type === 'campaign' ? `campaigns/posts/${post['no']}`: `groups/posts/${post['no']}`;
            const deleteResult = await server.deleteRequestData(endPoint);
            if(deleteResult['success'] !== 1)
            {
                return;
            }
            let index = null;
            for(let i = 0; i < postList.length; ++i)
            {
                if(postList[i]['no'] === post['no'])
                {
                    index = i;
                }
            }

            if(index !== null)
            {
                const reloadPostList = removeItem(postList, index);
                setPostList(reloadPostList);
                setBottomModalVisible(false);
            }
        }
        catch(error)
        {
            console.log(error);
        }
    }

    const handleSelectFilter = async (param) => {
            const endPoint = type === 'campaign' ? `campaigns/${no}/posts` : `groups/${no}/posts`;
            let result = null;
            if([null, undefined].includes(param))
            {
                result = await server.getRequestData(endPoint);
            }
            else 
            {
                result = await server.getRequestData(`${endPoint}?category_no=${param}`);
            }
            
            if(result['success'] !== 1)
            {
                return;
            }
            const posts = result['data']['posts'];
            setPostList(posts);
            setCurrFilterNo(param);
            setBottomModalVisible(false);
    }

    const handleAddPin = async (post) => {
        try
        {
            const endPoint = type === 'campaign' ? `campaigns/posts/${post.no}/pin` : `groups/posts/${post.no}/pin`
            const jsonData = await server.postRequestData(endPoint);
            if(jsonData['success'] !== 1)
            {
                return;
            }
            const updatedItem = jsonData['data']['updated_item'][0];

            let index = null;
            for(let i = 0; i < postList.length; ++i)
            {
                if(postList[i]['no'] === updatedItem['no'])
                {
                    index = i;
                    break;
                }
            }
            const currPost = postList[index];
            currPost['pin'] = updatedItem['pin'];
            const reloadPostList = removeItem(postList, index);
            setPostList([currPost, ...reloadPostList]);
            setInitBottomModalState(true); 
        }
        catch(error)
        {
            console.log(error);
        }
    }

    const handleDeletePin = async (post) => {
        try
        {
            let endPoint = type === 'campaign' ? `campaigns/posts/${post['no']}/pin` : `groups/posts/${post['no']}/pin` 
            const jsonData = await server.deleteRequestData(endPoint);
            if(jsonData['success'] !== 1)
            {
                return;
            }
            handleSelectFilter(null);
        }
        catch(error)
        {
            console.log(error);
        }
    }

    const handleClickFilter = () => {
        setBottomModalDataList([
            {type: 'callback', text: '전체보기', callback: () => handleSelectFilter(null), style: currFilterNo === null ? {color: '#FECE37' } : null},
            {type: 'callback', text: '자유글', callback: () => handleSelectFilter(1), style: currFilterNo === 1 ? {color: '#FECE37' } : null},
            {type: 'callback', text: '정보 공유', callback: () => handleSelectFilter(2), style: currFilterNo === 2 ? {color: '#FECE37' } : null},
            {type: 'callback', text: '가입 인사', callback: () => handleSelectFilter(3), style: currFilterNo === 3 ? {color: '#FECE37' } : null},
            {type: 'callback', text: '후기', callback: () => handleSelectFilter(4), style: currFilterNo === 4 ? {color: '#FECE37' } : null}
        ])
        setBottomModalVisible(true);
    }

    const handleBottomModal = (post) => {
        const path = type === 'campaign' ? `/campaign/community/post/${post['no']}/edit` : `/group/community/post/${post['no']}/edit`;
        
        if(isOwner)
        {
            if(post['user_no'] === userInfo['id'])
            {
                setBottomModalDataList([
                    {type: 'callback', text: post['pin'] ? '핀제거' : '핀고정' , callback: post['pin'] ? () => handleDeletePin(post) : () => handleAddPin(post)},
                    {type: 'redirect', text: '글수정', path: path},
                    {type: 'callback', text: '삭제', callback: () => deletePost(post), style: {color: '#DE0000'}}
                ])
                setBottomModalVisible(true);
            }
            else
            {
                setBottomModalDataList([
                    {type: 'callback', text: post['pin'] ? '핀제거' : '핀고정' , callback: post['pin'] ? () => handleDeletePin(post) : () => handleAddPin(post)}
                ])
                setBottomModalVisible(true);
            }
        }
        else
        {
            if(userInfo['id'] === post['user_no'])
            {
                setBottomModalDataList([
                    {type: 'redirect', text: '글수정', path: path},
                    {type: 'callback', text: '삭제', callback: () => deletePost(post), style: {color: '#DE0000'}}
                ])
                setBottomModalVisible(true);
            }
        }
    }

    const handleScroll = (e) => {
        const endPoint = type === 'campaign' ? `campaigns/${no}/posts?last_pos_no=${lastposNo}` : `groups/${no}/posts?last_post_no=${lastposNo}`;
        if(isLoading || isEnd) return;
        if(e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight)
        {
            setIsLoading(true);
            if(currFilterNo)
            {
                server.getRequestData(`${endPoint}&category_no=${currFilterNo}`, initCallback);
                return;
            }
            server.getRequestData(endPoint, initCallback);
        }
    }
    //PostListEnd
    const initCallback = (res) => {
        try
        {
            if(res['success'] !== 1)
            {
                return;
            }
            const posts = res['data']['posts'];
            
            if(posts.length > 0)
            {
                setPostList([...postList, ...posts]);
                setLastPosNo(posts[posts.length - 1]['no']);
            }
            else
            {
                setIsEnd(true);
            }
            setIsLoading(false);
        }
        catch(error)
        {
            console.log(error)
        }
    }

    useEffect(() => {
        if(isLoading || isEnd) return;
        setIsLoading(true);
        if(type === 'campaign')
        {
            server.getRequestData(`campaigns/${no}/posts`, initCallback);
            // if(userInfo['role'] === 'admin')
            // {
            //     setIsOwner(true);
            // }
        }
        else if(type === 'group')
        {
            server.getRequestData(`groups/${no}/posts`, initCallback);
            // server.getRequestData(`groups/${no}`, (res) => {
            //     if(res['success'] !== 1)
            //     {
            //         return;
            //     }
            //     if(res['data']['role'] === 'admin')
            //     {
            //         setIsOwner(true);
            //     }
            // })
        }
    }, [])

    useEffect(() => {
        if(initWriteFormState === true)
        {
            setWriteType(null);
            setWriteVisible(false);
            setWriteValue(null);
            setImageList([]);
            setInitWriteFormState(false);
        }
    }, [initWriteFormState])

    useEffect(() => {
        if(initCenterModalState === true)
        {
            setCenterModalVisible(false);
            setCenterModalDataList(null);
            setOnCenterModalComplete(null);
            setOnCenterModalCancel(null);
            setInitCenterModalState(false);
        }
    }, [initCenterModalState])

    useEffect(() => {
        if(initBottomModalState)
        {
            setBottomModalVisible(false);
            setBottomModalDataList([]);
            setInitBottomModalState(false);
        }
    }, [initBottomModalState])

    const lottieOptions = {
        loop: false,
        autoplay: true,
        renderer: 'svg',
        animationData: likeAnimation
    }

    return (
        <>
            <CommunitySection>
                <CommunityWrapper onScroll={handleScroll}>
                    <CommunityFilter onClickFilter={handleClickFilter}/>
                    <CommunityWriteForm 
                        onChangeWriteType={handleChangeWriteType}
                        onChangeWriteValue={handleChangeWriteValue}
                        onChangeImageList={handleChangeImageList}
                        onClickDeleteImage={handleClickDeleteImage}
                        onCancelWrite={handleCancelWrite}
                        onSubmit={handleSubmit}
                        writeType={writeType}
                        writeValue={writeValue}
                        currImgCapacity={currImgCapacity}
                        imageList={imageList}
                        writeVisible={writeVisible}
                        setWriteVisible={setWriteVisible}
                        setInitWriteFormState={setInitWriteFormState}
                        fileInputRef={fileInputRef}
                        type={type}
                    />
                    <CommunityList 
                        postList={postList}
                        userInfo={userInfo}
                        handleBottomModal={handleBottomModal}
                        handleAddLike={handleAddLike}
                        handleDeleteLike={handleDeleteLike}
                        currPostNo={currPostNo}
                        isLikeAnimation={isLikeAnimation}
                        lottieOptions={lottieOptions}
                        type={type}
                        isOwner={isOwner}
                        onCommentClick={(postNo) => history.push(`/campaign/${no}/post/${postNo}`)}
                    />
                </CommunityWrapper>
            </CommunitySection>
            <CenterModal 
                modalVisible={centerModalVisible} 
                dataList={centerModalDataList} 
                onComplete={onCenterModalComplete} 
                onCancel={onCenterModalCancel}
            />
            <BottomModal 
                visible={bottomModalVisible} 
                setVisible={setBottomModalVisible} 
                dataList={bottomModalDataList}
            />
        </>
    );
}

export default Community

const CommunitySection = styled.div`
  width: 100%;
  background-color: #f7f7f7;
  position: fixed;
  top: calc(100vw * (51 / 375));
  height: 100%;
  overflow-y: scroll;
`;
const CommunityWrapper = styled.div`
    width: 100%;
    background-color: #f7f7f7;
    padding: calc(100vw * (45 / 375)) calc(100vw * (16 / 375))
    calc(100vw * (100 / 375)) calc(100vw * (17 / 375));
    position: fixed;
    top: calc(100vw * (51 / 375));
    overflow-y: scroll;
    max-height: calc(100vh - calc(100vw * (51 / 375)));
    height: auto;
`;